<script>
    import { getArtworkURL } from "../utils.js";

    export let item;
    export let artSize = 40;
    // export let minimal = false;

    const music = MusicKit.getInstance();

    $: attrs = item.attributes;
    $: explicit = (attrs.contentRating == "explicit");
    $: artworkUrl = attrs && getArtworkURL(item, artSize, artSize) || '/missing-artwork.svg';
    $: subtitle = (() => {
        switch (item.type) {
            case "albums":
            case "library-albums":
            case "songs":
            case "library-songs":
                return attrs.artistName;
            case "playlists":
                return "Playlist";
            case "library-playlists":
                return "Personal playlist";
        }
    })();

    function handleDragStart(event) {
        console.log("item dragged", item);
        event.dataTransfer.clearData();
        event.dataTransfer.setData("application/json", JSON.stringify({ id: item.id, type: item.type }));
        // event.dataTransfer.setDragImage(img, img.width / 2, img.height / 2);
    }
</script>

<div class="root" on:click on:contextmenu|preventDefault>
    <div class="item"
        draggable="true"
        on:dragstart={handleDragStart}>
        <img class="art"
             src="{artworkUrl}"
             alt="{attrs.artistName} - {attrs.name}"
             draggable="false"
             style="--size: {artSize}px">
        <div class="desc">
            <div class="name-line" style="--template-columns: {explicit ? "auto min-content 1fr" : "auto 1fr"}">
                <div class="name" title="{attrs.name}">{attrs.name}</div>
                {#if explicit}
                    <div class="explicit" title="Explicit songs">E</div>
                {/if}
            </div>
            <div class="artist-album" title="{subtitle}">
                {subtitle}
            </div>
        </div>
    </div>
</div>

<style>
    .root {
        position: relative;
    }

    .item {
        display: grid;
        grid-gap: 10px;
        grid-template-areas: "item-art desc";
        grid-template-rows: 1fr;
        grid-template-columns: min-content 1fr;
        padding: var(--song-item-padding, 10px);
        color: var(--song-item-fg-color, var(--song-fg-color, #E0E0E0));
        background-color: var(--song-item-bg-color, transparent);
        border-radius: var(--song-item-border-radius, 5px);
        cursor: pointer;
    }

    .item:hover, .item:global(.context-menu-active) {
        color: var(--song-item-hover-fg-color, #232323);
        background-color: var(--song-item-hover-bg-color, #E0E0E0);
    }

    .art {
        grid-area: item-art;
        border-radius: 5px;
        width: var(--size);
        height: var(--size);
    }

    .desc {
        grid-area: desc;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .name-line,
    .artist-album {
        display: inline;
    }

    .name-line {
        grid-area: song-name;
        display: grid;
        grid-template-rows: 1fr;
        grid-template-columns: var(--template-columns);
        grid-gap: 5px;
    }

    .name,
    .artist-album {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .name {
        font-weight: bold;
    }

    .artist-album {
        font-size: 13px;
    }

    .explicit {
        font-size: 15px;
        font-weight: bold;
        color: var(--song-item-explicit-fg-color, var(--app-explicit-fg-color));
        background-color: var(--song-item-explicit-bg-color, var(--app-explicit-bg-color));
        border-radius: 2px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: left;
        padding: 0 5px;
    }
</style>
